import React from 'react';

export default function ExamModal({ modalOpen, level, modalMode, modalData, orgs, types, cycles, onClose, onChange, onSave }) {
  if (!modalOpen) return null;

  const levelFields = {
    org: (
      <>
        <input placeholder="name" value={modalData?.name||''} onChange={e=>onChange({...modalData,name:e.target.value})} className="border rounded px-2 w-full" />
        <input placeholder="slug" value={modalData?.slug||''} onChange={e=>onChange({...modalData,slug:e.target.value})} className="border rounded px-2 w-full" />
        <select value={modalData?.status||'active'} onChange={e=>onChange({...modalData,status:e.target.value})} className="border rounded px-2 w-full">
          <option value="active">Active</option>
          <option value="draft">Draft</option>
          <option value="suspended">Suspended</option>
        </select>
      </>
    ),
    type: (
      <>
        <input placeholder="name" value={modalData?.name||''} onChange={e=>onChange({...modalData,name:e.target.value})} className="border rounded px-2 w-full" />
        <select value={modalData?.organization_id||''} onChange={e=>onChange({...modalData,organization_id:e.target.value})} className="border rounded px-2 w-full">
          <option value="">-- organization --</option>
          {orgs?.map(o=><option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
        <select value={modalData?.status||'active'} onChange={e=>onChange({...modalData,status:e.target.value})} className="border rounded px-2 w-full">
          <option value="active">Active</option>
          <option value="draft">Draft</option>
          <option value="suspended">Suspended</option>
        </select>
      </>
    ),
    cycle: (
      <>
        <input placeholder="name" value={modalData?.name||''} onChange={e=>onChange({...modalData,name:e.target.value})} className="border rounded px-2 w-full" />
        <input type="number" placeholder="year" value={modalData?.year||''} onChange={e=>onChange({...modalData,year:e.target.value})} className="border rounded px-2 w-full" />
        <select value={modalData?.exam_type_id||''} onChange={e=>onChange({...modalData,exam_type_id:e.target.value})} className="border rounded px-2 w-full">
          <option value="">-- exam type --</option>
          {types?.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
        <select value={modalData?.status||'active'} onChange={e=>onChange({...modalData,status:e.target.value})} className="border rounded px-2 w-full">
          <option value="active">Active</option>
          <option value="draft">Draft</option>
          <option value="suspended">Suspended</option>
        </select>
      </>
    ),
    test: (
      <>
        <input placeholder="title" value={modalData?.title||''} onChange={e=>onChange({...modalData,title:e.target.value})} className="border rounded px-2 w-full" />
        <input type="number" placeholder="duration_minutes" value={modalData?.duration_minutes||''} onChange={e=>onChange({...modalData,duration_minutes:e.target.value})} className="border rounded px-2 w-full" />
        <input type="number" placeholder="total_questions" value={modalData?.total_questions||''} onChange={e=>onChange({...modalData,total_questions:e.target.value})} className="border rounded px-2 w-full" />
        <input type="number" placeholder="marks_per_correct" value={modalData?.marks_per_correct||''} onChange={e=>onChange({...modalData,marks_per_correct:e.target.value})} className="border rounded px-2 w-full" />
        <input type="number" placeholder="negative_mark" value={modalData?.negative_mark||''} onChange={e=>onChange({...modalData,negative_mark:e.target.value})} className="border rounded px-2 w-full" />
        <input type="number" placeholder="total_marks" value={modalData?.total_marks||''} readOnly className="border rounded px-2 w-full bg-gray-100" />
        <select value={modalData?.exam_cycle_id||''} onChange={e=>onChange({...modalData,exam_cycle_id:e.target.value})} className="border rounded px-2 w-full">
          <option value="">-- exam cycle --</option>
          {cycles?.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <select value={modalData?.status||'active'} onChange={e=>onChange({...modalData,status:e.target.value})} className="border rounded px-2 w-full">
          <option value="active">Active</option>
          <option value="draft">Draft</option>
          <option value="suspended">Suspended</option>
        </select>
      </>
    )
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h4 className="text-lg font-semibold mb-2">{modalMode==='edit'?'Edit':'Add'} {level}</h4>
        <div className="space-y-2">{levelFields[level]}</div>
        <div className="flex justify-end space-x-2 mt-4">
          <button className="px-3 py-1 rounded bg-gray-300" onClick={onClose}>Cancel</button>
          <button className="px-3 py-1 rounded bg-blue-600 text-white" onClick={onSave}>{modalMode==='edit'?'Update':'Add'}</button>
        </div>
      </div>
    </div>
  );
}
